"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectEventFetchItem = exports.selectLinkedEvents = exports.selectActiveEvents = exports.selectEventShortStatistics = exports.selectEventStatistics = exports.getFetchItemsStatus = exports.selectEventTournamentId = exports.selectEventStatusById = exports.selectLastProbabilitiesVersion = exports.selectEventById = exports.getEventId = exports.getEvents = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const filter_1 = __importDefault(require("../../../utils/functions/filter"));
const slices_1 = require("../../../utils/@reduxjs/slices");
const constants_1 = require("../../BasketProvider/constants");
const linkedEvents_1 = require("../../../utils/events/linkedEvents");
const array_1 = require("../../../utils/array");
const api_1 = require("../../../utils/api");
const slice_1 = require("../slice");
const getEvents = (state) => state.eventsProvider.events.entries || slice_1.initialState.events.entries;
exports.getEvents = getEvents;
const getEventId = (_state, eventId) => eventId;
exports.getEventId = getEventId;
const selectEventById = (state, eventId) => (0, exports.getEvents)(state)[eventId];
exports.selectEventById = selectEventById;
const selectLastProbabilitiesVersion = (state, eventId) => state.eventsProvider.events.lastProbabilitiesVersion[eventId];
exports.selectLastProbabilitiesVersion = selectLastProbabilitiesVersion;
const selectEventStatusById = (state, eventId) => { var _a; return (_a = (0, exports.selectEventById)(state, eventId)) === null || _a === void 0 ? void 0 : _a.status; };
exports.selectEventStatusById = selectEventStatusById;
const selectEventTournamentId = (state, eventId) => { var _a; return (_a = state.eventsProvider.events.entries[eventId]) === null || _a === void 0 ? void 0 : _a.tournament.id; };
exports.selectEventTournamentId = selectEventTournamentId;
const getFetchItemsStatus = (state) => state.eventsProvider.events.fetchItems.loading;
exports.getFetchItemsStatus = getFetchItemsStatus;
const selectEventStatistics = (state, eventId) => {
    return (state.eventsProvider.eventsStatistics.entries[eventId] ||
        slice_1.initialState.eventsStatistics.entries[eventId]);
};
exports.selectEventStatistics = selectEventStatistics;
const selectEventShortStatistics = (state, eventId) => { var _a; return (_a = (0, exports.selectEventById)(state, eventId)) === null || _a === void 0 ? void 0 : _a.statistics; };
exports.selectEventShortStatistics = selectEventShortStatistics;
exports.selectActiveEvents = (0, toolkit_1.createSelector)(exports.getEvents, (events) => (0, slices_1.toIdsMap)((0, filter_1.default)(events, (event) => !constants_1.endedEventStatus.includes(event.status))));
exports.selectLinkedEvents = (0, toolkit_1.createSelector)([exports.getEvents, (_, eventId) => eventId], (events, eventId) => {
    const mainEvent = events[eventId];
    if (mainEvent === undefined) {
        return array_1.EMPTY_ARRAY;
    }
    const linkedEventIds = (0, linkedEvents_1.getLinkedEventIds)(mainEvent);
    const linkedEvents = linkedEventIds
        .map((eventId) => events[eventId])
        .filter((event) => event !== undefined);
    return linkedEvents;
});
const selectEventFetchItem = (state, eventId) => {
    var _a;
    return (_a = state.eventsProvider.events.fetchItem[eventId]) !== null && _a !== void 0 ? _a : api_1.requestInitialState;
};
exports.selectEventFetchItem = selectEventFetchItem;
//# sourceMappingURL=eventsSelectors.js.map